<template>
    <div class="upload-one">
      <el-upload class="avatar-uploader "
        action="/rest/gongye/saas/upload/image"
        :on-error="uploadError"
        :on-exceed="uploadExc"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :headers="headers"
        :before-upload="beforeAvatarUpload"
        accept="image/png, image/jpeg,image/jpeg"
        :on-success="uploadSuccessOne"
        list-type="picture"
        :show-file-list="false"
        :disabled='ifDisable'
      >
      <img v-if="picUrl" :src="picUrl" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过5mb，建议宽高比为3.5:1</div>
      </el-upload>
    </div>
    

</template>

<script>
    import {
        upLoadImg
    }
    from '@/Mixin/upLoadImg'
    export default {
        props: {
          ifDisable:{
            type: Boolean,
            default: false
          },
          initDone: { // 外层初始化完毕
            type: Boolean,
            default: false
          },
          initUrl: { // 初始化图片
            type: String,
            default: ''
          }
        },
        mixins: [upLoadImg],
        data() {
            return {
                picUrl: '',
            }
        },
        methods: {
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg'||file.type === 'image/png'||file.type === 'image/jpg';
                const isLt2M = file.size / 1024 / 1024 < 5;
                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG 或png格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 5MB!');
                }
                return isJPG && isLt2M;
            },
            saveImg() {
                /**
                 * [if description]
                 * @param  {[uploadImgList]}  初始化数据 响应初始化 添加 删除
                 * @param {[picUrl]}      uploadImgList 最后转化为 picUrl 的值
                 */

                if (this.uploadImgList) {
                    let len = this.uploadImgList.length
                    if (this.uploadImgList[len - 1].upLoadUrl) { // 初始化的图片
                        this.picUrl = this.uploadImgList[len - 1].upLoadUrl
                        // this.$set(this, 'picUrl', this.uploadImgList[len - 1].upLoadUrl)
                    } else if (this.uploadImgList[len - 1].response.data) { // 上传后的图片
                        this.picUrl = this.uploadImgList[len - 1].response.data
                    }
                }

            },
            uploadSuccessOne(response, file, fileList) {
              this.uploadImgList = fileList
              this.saveImg()
              this.$emit('upload-done', this.picUrl)
            }
        },
        components: {

        },
        computed: {

        },
        mounted() {

        },
        watch: {
          initDone(v) {
            if(v) {
              this.getImgList(this.initUrl)
              this.saveImg()
            }
          },
          initUrl: {
            handler(v) {
              if(v) {
                this.getImgList(v)
                this.saveImg()
              }
            },
            immediate: true
          }

        },
        created() {

        }
    }
</script>

<style lang="scss">


</style>
